import React from 'react';
import './CollabGuidelines.css';
import CTAButton from '../../../buttons/CTAButton';

interface CollabGuidelinesProps {
  isOpen: boolean;
  onClose: () => void;
  type: 'content_mission' | 'things_to_avoid' | 'products' | 'required_hashtags';
  content: string;
}

const CollabGuidelines: React.FC<CollabGuidelinesProps> = ({ 
  isOpen, 
  onClose, 
  type, 
  content 
}) => {
  const getTitle = () => {
    switch (type) {
      case 'content_mission':
        return 'Content Mission';
      case 'things_to_avoid':
        return 'Things to Avoid';
      case 'products':
        return 'Products';
      case 'required_hashtags':
        return 'Required Tags';
      default:
        return '';
    }
  };

  return (
    <div className={`guidelines-modal-overlay ${isOpen ? 'open' : ''}`}>
      <div className="guidelines-modal-content">
        <div className="guidelines-modal-header">
          <button className="guidelines-cancel-button" onClick={onClose}>
            Cancel
          </button>
          <h2>{getTitle()}</h2>
        </div>
        
        <div className="guidelines-modal-body">
          <div className="guidelines-content">
            {content}
          </div>
        </div>

        <div className="guidelines-modal-footer">
          <CTAButton 
            text="Got it" 
            onClick={onClose} 
            isActive={true}
          />
        </div>
      </div>
    </div>
  );
};

export default CollabGuidelines; 